import { useMemo } from 'react';

import type { Event } from 'components/events/events/types';
import usePluggableSecurityEventActions from 'security-app/components/SecurityEvents/Alerts/usePluggableSecurityEventActions';

const useSecurityEventBulkAction = (events: Array<Event>) => {
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableSecurityEventActions(
    events,
    true,
  );

  const actions = useMemo(() => [pluggableActions].filter(Boolean), [pluggableActions]);

  return { actions, pluggableActionModals };
};

export default useSecurityEventBulkAction;
